// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"77010904","453":"8a7db4d3","777":"4378f129"}[chunkId] + ".chunk.js";
};